import { SymbolType } from "@lib/titan2-slingo/dist/api/model/enum/SymbolType";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { zip } from "../../../utils/zip";
/**
 * A note describing win line information.
 */
export class GameWinLineNote extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
        this.landscapeProperties = landscapeProperties;
        const winLineFeatureConfig = this.model.getFeatureConfig().getWinLineFeatureConfig();
        const numberMultipliers = winLineFeatureConfig.getMultipliers(SymbolType.NUMBER);
        const numberThreshold = winLineFeatureConfig.getThreshold(SymbolType.NUMBER);
        const jokerMultipliers = winLineFeatureConfig.getMultipliers(SymbolType.JOKER);
        const jokerThreshold = winLineFeatureConfig.getThreshold(SymbolType.JOKER);
        const stake = this.model.getCurrentStake();
        TitanSprite.createSprite(this, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
        zip(this.landscapeProperties.symbolCountProperties, this.portraitProperties?.symbolCountProperties)
            .map(([landscape, portrait], i) => TitanText.createField(this, `symbol-count-${i}`, landscape, portrait))
            .reverse()
            .forEach((text, i) => {
            text.setText(`${Math.min(numberThreshold, jokerThreshold) + i + 1}`);
        });
        zip(this.landscapeProperties.numberPayoutProperties, this.portraitProperties?.numberPayoutProperties)
            .map(([landscape, portrait], i) => TitanText.createField(this, `number-payout-${i}`, landscape, portrait))
            .reverse()
            .forEach((text, i) => text.setText(`${numberMultipliers[numberThreshold + i]}x`));
        zip(this.landscapeProperties.jokerPayoutProperties, this.portraitProperties?.jokerPayoutProperties)
            .map(([landscape, portrait], i) => TitanText.createField(this, `joker-payout-${i}`, landscape, portrait))
            .reverse()
            .forEach((text, i) => {
            text.setText(`${jokerMultipliers[jokerThreshold + i]}x`);
        });
    }
}
//# sourceMappingURL=GameWinLineNote.js.map